import { render } from "./SearchList.vue?vue&type=template&id=256d9205"
import script from "./SearchList.js?vue&type=script&lang=js"
export * from "./SearchList.js?vue&type=script&lang=js"

import "./SearchList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__